import { render, staticRenderFns } from "./searchView.vue?vue&type=template&id=0c4a7cb0&"
import script from "./searchView.vue?vue&type=script&lang=js&"
export * from "./searchView.vue?vue&type=script&lang=js&"
import style0 from "./searchView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports